/**
 * Shared constants for AI Console pages.
 */

export const APPLETS = [
  { id: 'chat', label: 'Chat' },
  { id: 'talent', label: 'Talent' },
  { id: 'business_intelligence', label: 'Business Intelligence' },
  { id: 'content', label: 'Content' },
  { id: 'prd_generator', label: 'PRD Generator' },
  { id: 'executive_command_center', label: 'Executive Command Center' },
] as const

export const SANDBOX_MODELS = [
  { id: 'gpt-4o', label: 'gpt-4o' },
  { id: 'gpt-4o-mini', label: 'gpt-4o-mini' },
  { id: 'gpt-4.1', label: 'gpt-4.1' },
  { id: 'gpt-4.1-mini', label: 'gpt-4.1-mini' },
  { id: 'claude-sonnet-4-20250514', label: 'Claude Sonnet 4' },
  { id: 'claude-3-5-haiku-20241022', label: 'Claude 3.5 Haiku' },
] as const

export const PERIOD_OPTIONS = [
  { label: '7 days', value: 7 },
  { label: '14 days', value: 14 },
  { label: '30 days', value: 30 },
] as const

/** Convert an applet_id to a display label. */
export function appletLabel(id: string): string {
  return id.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

/** Format USD cost for display. */
export function fmtCost(cost: number | undefined): string {
  if (cost == null) return '—'
  if (cost < 0.01) return '$0.00'
  if (cost < 1) return `$${cost.toFixed(3)}`
  return `$${cost.toFixed(2)}`
}

/** Format milliseconds duration for display. */
export function fmtDuration(ms: number | undefined): string {
  if (ms == null) return '—'
  if (ms < 1_000) return `${ms.toFixed(0)}ms`
  if (ms < 60_000) return `${(ms / 1_000).toFixed(1)}s`
  return `${(ms / 60_000).toFixed(1)}m`
}

/** Format a ratio as a percentage. */
export function fmtPct(count: number, total: number): string {
  if (total === 0) return '0%'
  return `${((count / total) * 100).toFixed(1)}%`
}

/** Format an ISO date string for display. */
export function fmtDate(iso: string): string {
  const date = new Date(`${iso}T00:00:00`)
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}
